 
const Forbidden = () => {
  
  return (
      <h2>Forbidden....</h2>
  );
};

export default Forbidden;
